export const frontmatter = {
    "draft": false,
    "title": "Contacts",
    "description": "Contact and contact group management in OnnIA.",
    "sidebar_label": "Overview",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []